import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentGql } from './WorkbooksDisplayGridRowDataFragmentGql';

export const VirtualConnectionDownstreamWorkbooksFilteredByTableQueryGql: DocumentNode = gql`
query VirtualConnectionDownstreamWorkbooksFilteredByTableQuery(
  $vizportalUrlId: String!,
  $selectedTableId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: WorkbookSortOrder!
) {
  virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
    tablesConnection(filter: { id: $selectedTableId }) {
      nodes {
        downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...WorkbooksDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentGql}
`;
